import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useEffect } from 'react';
import { Box, Card, CardContent, TextField, Typography, createTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },

    rowContentDescription: {
        flex: 1,
        display: "flex",
        flexDirection: 'column'
    },
    formControlLabel : {
        fontWeight: 900
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
}));
export default function SocialMasters(props) {
    // console.log("props", props);
    const classes = useStyles();
    const [value, setValue] = React.useState('');
    const [data, setData] = React.useState();
    const [serviceRequest, setServiceRequest] = React.useState();

    useEffect(() => {
        if (props.historyData && props.historyData !== null) {
            setValue(props.historyData.options[0].masterID)
            setServiceRequest(props.historyData.options[0].specialRequest)
        } else {
            if (props.socialData) {
                let selectedData = props.socialData.find(i => i.socialResponsibilityID !== 0);
                if (selectedData) {
                    setValue(selectedData.masterID);
                    if (selectedData.specialRequest !== null) {
                        setServiceRequest(selectedData.specialRequest)
                    }
                }
            }
            // props.socialData && props.socialData.map((val) => {
            //     debugger
            //     if (val.specialRequest !== null) {
            //         setValue(val.masterID)
            //         setServiceRequest(val.specialRequest)
            //     }
            // })
        }
    }, [props.socialData, props.historyData])

    useEffect(() => {
        setData(props.socialData)
    }, [props])
    const handleRadioChange = (event) => {
        setValue(event.target.value);
        if (props.historyData && props.historyData !== null) {
            // console.log("if",props.historyData.options[0].masterID,event.target.value == props.historyData.options[0].masterID && val.isRequestTimeSlot );
            if (event.target.value == props.historyData.options[0].masterID && val.isRequestTimeSlot) {
                setServiceRequest(props.historyData.options[0].specialRequest)
            } else {
                setServiceRequest("")
            }
        } else {
            props.socialData && props.socialData.map((val) => {
                // console.log("else",val);
                // if (val.specialRequest !== null) {
                    if (event.target.value == val.masterID && val.isRequestTimeSlot) {
                        // console.log("val",val);
                        setServiceRequest(val.specialRequest !== null ? val.specialRequest : "")
                    } else {
                        // console.log("else-val");

                        setServiceRequest("")
                    }
                // }
            })
        }
        props.handleRadioChange();
        props.onMasterchange(event.target.value, null);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
    };
    const onServiceRequestChange = (val, item) => {
        setServiceRequest(val)
        props.onMasterchange(value, val);
    }
    // console.log("value", value);
    return (
        <form onSubmit={handleSubmit}>
            <FormControl sx={{ width: '100%' }} variant="standard">
                <RadioGroup
                    aria-labelledby="demo-error-radios"
                    name="Social Impact"
                    value={value}
                    onChange={handleRadioChange}
                >
                    {data && data.length > 0 ? data.map((val) => {
                        return (
                            <>
                                <Card
                                    classes={{ root: classes.paperContent }}
                                    sx={{ m: 1 }}
                                >
                                    <CardContent
                                        sx={{ p: 2 }}
                                        className={classes.cardContent}>
                                        <Box className={classes.rowContent}>
                                            <Box className={classes.rowContentDescription}>
                                                <FormControlLabel value={val.masterID} control={<Radio />} label={<Typography className={classes.formControlLabel}>{val.title}</Typography>} />
                                                <Box sx={{ pl: 5 }}><div style={{ paddingBottom: "10px" }}></div><span dangerouslySetInnerHTML={{ __html: val.description }}
                                                >
                                                </span></Box>
                                                {(value == val.masterID && val.isRequestTimeSlot) && <TextField
                                                    size="small"
                                                    label="Requested Timeslot"
                                                    fullWidth
                                                    display="none"
                                                    minRows={2}
                                                    id="outlined-basic"
                                                    value={serviceRequest}
                                                    onChange={(event) => {
                                                        onServiceRequestChange(event.target.value, val)
                                                    }}
                                                    inputProps={{ maxLength: 250 }}
                                                />}
                                            </Box>


                                        </Box>
                                    </CardContent>
                                </Card>

                            </>
                        )
                    }) : <Card
                        classes={{ root: classes.paperContent }}
                        sx={{ width: '100%' }}>
                        <CardContent
                            sx={{ p: 2 }}
                            className={classes.cardContent}>
                            <Box className={classes.rowContent}>
                                No data found
                            </Box>
                        </CardContent>
                    </Card>}
                </RadioGroup>

            </FormControl>
        </form>
    );
}
